module.exports = __webpack_public_path__ + "static/img/weixian.460bc37e.png";